import React from 'react';
import { Activity } from './types';

// Activity Header Component
export const ActivityHeader: React.FC<{ activity: Activity }> = ({ activity }) => {
  return (
    <div className="flex items-center justify-between mb-6">
      <h2 className="text-2xl font-bold">{activity.title}</h2>
      <span className="px-2 py-1 bg-blue-100 text-blue-800 text-xs font-medium rounded-full">
        {activity.type}
      </span>
    </div>
  );
};

// Activity Info Component
export const ActivityInfo: React.FC<{ activity: Activity }> = ({ activity }) => {
  return (
    <div className="bg-gray-50 p-4 rounded-md space-y-2">
      <div className="flex flex-col">
        <span className="text-sm font-medium text-gray-500">Title:</span>
        <span className="text-sm text-gray-900">{activity.title}</span>
      </div>
      <div className="flex flex-col">
        <span className="text-sm font-medium text-gray-500">Description:</span>
        <span className="text-sm text-gray-900">{activity.description || 'No description'}</span>
      </div>
    </div>
  );
}; 